<script setup lang="ts">
import { defineProps, onMounted, ref } from 'vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
const props = defineProps(['params'])
const partnerId = ref()
const phone = ref()
const mobile = ref()
const email = ref()

onMounted(() => {
  if (props.params.data.parentId && props.params.data.title) {
    partnerId.value = props.params.data.parentId.id
  } else {
    partnerId.value = props.params.data.id
  }

  phone.value = props.params.data.phone
  mobile.value = props.params.data.mobile
  email.value = props.params.data.email
})
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="w-fit">
      <ButtonDaisy text="Editer" @click="params.onClick(params.data)" />
    </div>
  </div>
</template>
